<template>
    <ul class="feature-list">
        <li v-for="featureDescription in features">
            <span>{{ featureDescription }}</span>
        </li>
    </ul>
</template>

<script>
export default {
    name: "FeatureList",
    props: {
        features: {
            type: Array,
            required: true,
        }
    }
}
</script>
